export default __webpack_public_path__ + "static/media/MK.c7c6f3c3.svg";